import React, { useMemo, ComponentProps } from 'react';
import intersection from 'lodash/intersection';
import { Box, Typography, Paper, useTheme } from '@mui/material';
import { Post } from 'src/models/fragments';
import { useAllPosts } from 'hooks/useAllPosts';
import SimplePostItem from 'components/SimplePostItem';

const MAX_COUNT = 5;

interface Props extends ComponentProps<typeof Paper> {
  currentPost: NonNullable<Post>;
  tags: readonly (string | null)[];
  onClickPost?: (path: string) => void;
}
const RelatedPosts = ({ tags, currentPost, onClickPost, ...rest }: Props) => {
  const { spacing, typography } = useTheme();
  const posts = useAllPosts();
  const relatedPosts = useMemo(() => {
    return posts
      .filter(post => post.frontmatter?.title !== currentPost.frontmatter?.title)
      .map(post => ({
        post,
        tags: intersection(post.frontmatter?.tags ?? [], tags),
      }))
      .filter(({ tags }) => tags.length > 0)
      .sort((a, b) => b.tags.length - a.tags.length)
      .map(v => v.post)
      .slice(0, MAX_COUNT);
  }, [currentPost, posts, tags]);

  if (relatedPosts.length === 0) {
    return null;
  }

  return (
    <Paper variant="outlined" {...rest} sx={{ padding: spacing(2), background: 'transparent', borderStyle: 'dashed' }}>
      <Typography sx={{ marginBottom: spacing(2) }} fontWeight={typography.fontWeightBold}>
        관련 포스팅 보러가기
      </Typography>
      <Box>
        {relatedPosts.map(post => (
          <SimplePostItem key={post.fields?.path} post={post} onClick={onClickPost} />
        ))}
      </Box>
    </Paper>
  );
};

export default RelatedPosts;
